import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=53fe8ea3&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "@/assets/coupon/register.css?vue&type=style&index=0&id=53fe8ea3&prod&scoped=true&lang=css&external"
import style1 from "./Register.vue?vue&type=style&index=1&id=53fe8ea3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe8ea3",
  null
  
)

export default component.exports